import { useEffect } from "react";
import { Navigate, useNavigate, useRoutes } from "react-router-dom";
import { useDispatch } from "react-redux";
import jwt_decode from "jwt-decode";

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.

// redux
import { validateToken } from "./store/slices/userSlice";
// layouts
import PreAuthWrapper from "./containers/PreAuthWrapper";
import AuthWrapper from "./containers/AuthWrapper";
// import NotFound from './pages/Page404';
// pages
import Application from "./pages/Application";
import ApplicationsList from "./pages/ApplicationsList";
import Login from "./pages/Login";
import Register from "./pages/Register";
import NotFound from "./pages/NotFound";
import CustomerList from "./pages/CustomerList";
import AcceptRequestToJoin from "./pages/AcceptRequestToJoin";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import UserProfile from "./components/UserProfile";
import UserSettings from "./components/UserSettings";
import OrganisationProfile from "./components/OrganisationProfile";
// import Billing from "./components/Billing";
import Subscribe from "./components/Subscribe";
import Payment from "./components/Payment";
import Privacy from "./pages/Privacy";
import { pageRoutes } from "./constants";
import EmailVerified from "./pages/EmailVerified";
import UserList from "./pages/UserList";
import OrganisationList from "./pages/OrganisationList";

// ----------------------------------------------------------------------

function handleDecode(token) {
  if (token && token.length > 12) {
    const now = Date.now() / 1000;
    const decoded = jwt_decode(token);
    return decoded.exp < now;
  }

  return true;
}

export default function Router(props) {
  const token = localStorage.token;
  const isTokenExpired = handleDecode(token);
  // const isTokenExpired = false;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = localStorage.user;

  // An expired token is already treated as logged out; validating it would 401 and bounce public pages (register, reset password) to login
  async function handleValidateToken() {
    if (token && !isTokenExpired) await dispatch(validateToken()).unwrap();
  }

  function noToken() {
    if (isTokenExpired) return <PreAuthWrapper {...props} />;
  }

  useEffect(() => {
      handleValidateToken();
  }, []);

  return useRoutes([
    {
      path: "/",
      element: noToken(),
      children: [
        { path: "register", element: <Register /> },
        { path: "login", element: <Login /> },
        { path: "privacy", element: <Privacy /> },
        // { path: "forgotpassword", element: <Password /> },
        // { path: "reset-password/:resetToken", element: <UpdatePassword /> },
        { path: "404", element: <NotFound /> },
        { path: "/", element: <Navigate to={pageRoutes.LOGIN} /> },
      ],
    },
    {
      path: "/password",
      element: <PreAuthWrapper {...props} />,
      children: [
        { path: "forgot", element: <ForgotPassword /> },
        { path: "reset/:key", element: <ResetPassword user={user} /> },
      ],
    },
    {
      path: "/dashboard",
      element: !isTokenExpired ? (
        <AuthWrapper {...props} />
      ) : (
        <Navigate to="/" />
      ),
      children: [
        { path: "applications", element: <ApplicationsList /> },
        { path: "application/", element: <Application /> },
        { path: "application/:applicationId", element: <Application /> },
        { path: "customers", element: <CustomerList /> },
        { path: "users", element: <UserList /> },
        { path: "organisations", element: <OrganisationList /> },

        // {
        //   path: "/dashboard",
        //   element: (
        //     <Navigate to={`/dashboard`} />
        //   ),
        // },
      ],
    },
    {
      path: "/account",
      element: !isTokenExpired ? (
        <AuthWrapper {...props} />
      ) : (
        <Navigate to="/" />
      ),
      children: [
        { path: "profile", element: <UserProfile /> },
        { path: "organisation", element: <OrganisationProfile /> },
        { path: "settings", element: <UserSettings /> },
        // { path: "billing", element: <Billing /> },

        // {
        //   path: "/dashboard",
        //   element: (
        //     <Navigate to={`/dashboard`} />
        //   ),
        // },
      ],
    },
    {
      path: pageRoutes.EMAIL_VERIFIED,
      element: <EmailVerified />,
    },
    {
      path: pageRoutes.EMAIL_VERIFICATION_FAILED,
      element: <EmailVerified />,
    },
    {
      path: pageRoutes.REGISTRATION_APPROVED,
      element: <AcceptRequestToJoin />,
    },
    {
      path: pageRoutes.REGISTRATION_ALREADY_APPROVED,
      element: <AcceptRequestToJoin />,
    },
    {
      path: pageRoutes.REGISTRATION_APPROVAL_FAILED,
      element: <AcceptRequestToJoin />,
    },
    {
      path: "/subscribe",
      element: !isTokenExpired ? (
        <AuthWrapper {...props} />
      ) : (
        <Navigate to="/" />
      ),
      children: [
        { path: "start", element: <Subscribe /> },
        {
          path: "payment-details",
          element: <Payment />,
        },
        // { path: "success", element: <UserSettings /> },
        // { path: "cancelled", element: <Billing /> },

        // {
        //   path: "/dashboard",
        //   element: (
        //     <Navigate to={`/dashboard`} />
        //   ),
        // },
      ],
    },
    // {
    //   path: "/setup",
    //   element: <Navigate to="/" />,
    // },

    { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}
